import { render, staticRenderFns } from "./FlagsCard.vue?vue&type=template&id=6cfc9d20&"
import script from "./FlagsCard.vue?vue&type=script&lang=js&"
export * from "./FlagsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports